import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const SUCCESS_MESSAGE_DURATION = 5000;

class ShopyphoneCartUpsells extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    const button = event.target.closest('[data-sp-upsell-add]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalLabel = button.textContent;
    const liveRegion = this.querySelector('[data-sp-upsell-live]');
    const messages = {
      adding: this.dataset.adding || '',
      added: this.dataset.added || '',
      failed: this.dataset.failed || '',
      continue: this.dataset.continue || '',
      refreshFailed: this.dataset.refreshFailed || '',
    };
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = messages.adding;
    if (liveRegion) liveRegion.textContent = '';

    const cartComponents = [...document.querySelectorAll('cart-items-component')];
    const sections = cartComponents
      .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    }));

    try {
      const body = new FormData();
      body.set('id', variantId);
      body.set('quantity', '1');
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname);
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const payload = await response.json();
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || messages.failed);
      }
      const cartResponse = await fetch(Theme.routes.cart_url + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!cartResponse.ok) throw new Error(messages.refreshFailed);
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          sections: payload.sections,
          items: cart.items,
          itemCount: cart.item_count,
          source: 'shopyphone-cart-upsells',
          didError: false,
        },
      });
      if (liveRegion) {
        liveRegion.textContent = messages.added;
        window.setTimeout(() => { liveRegion.textContent = ''; }, SUCCESS_MESSAGE_DURATION);
      }
    } catch (error) {
      deferred.reject(error);
      const message = error instanceof Error ? error.message : messages.failed;
      button.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
      if (liveRegion) liveRegion.textContent = message + '. ' + messages.continue;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  };
}

if (!customElements.get('shopyphone-cart-upsells')) {
  customElements.define('shopyphone-cart-upsells', ShopyphoneCartUpsells);
}
